import {
  formatTimelineTimestamp,
  timelineDirectionBadge,
  timelineRoleLabel,
} from "../../../utils/partnerWhatsappConversationDetailViewModel";

function TimelineBadge({ tone, label }) {
  return (
    <span className={`partner-whatsapp-badge partner-whatsapp-badge--${tone}`}>{label}</span>
  );
}

export default function PartnerWhatsappTimelineFeed({ items = [] }) {
  if (!items.length) {
    return (
      <p className="partner-whatsapp-empty muted">
        No WhatsApp timeline events found yet.
      </p>
    );
  }

  return (
    <ol className="partner-whatsapp-timeline">
      {items.map((item) => {
        const direction = timelineDirectionBadge(item);
        const role = timelineRoleLabel(item);
        const title =
          item.type === "audit"
            ? item.label || "Workflow update"
            : item.preview || "WhatsApp message";

        return (
          <li key={item.id || `${item.type}-${item.occurredAt}-${title}`} className="partner-whatsapp-timeline__item">
            <div className="partner-whatsapp-timeline__badges">
              <TimelineBadge tone={direction.tone} label={direction.code} />
              <TimelineBadge tone="slate" label={role} />
              {item.status ? (
                <span className="partner-whatsapp-timeline__status">{item.status}</span>
              ) : null}
            </div>
            <div className="partner-whatsapp-timeline__body">
              <strong>{title}</strong>
              {item.description ? (
                <p className="partner-whatsapp-timeline__description muted">{item.description}</p>
              ) : null}
              {item.templateName ? (
                <p className="partner-whatsapp-timeline__meta muted">
                  Template: {item.templateName}
                </p>
              ) : null}
            </div>
            <time className="partner-whatsapp-timeline__time muted">
              {formatTimelineTimestamp(item.occurredAt)}
            </time>
          </li>
        );
      })}
    </ol>
  );
}
